import { Button } from '../ui/Button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/DropdownMenu'

const languages = [
  { code: 'en', name: 'English' },
  { code: 'ko', name: '한국어' },
  { code: 'ja', name: '日本語' },
  { code: 'zh', name: '中文' },
  { code: 'es', name: 'Español' },
  { code: 'fr', name: 'Français' },
  { code: 'de', name: 'Deutsch' },
  { code: 'pt', name: 'Português' },
  { code: 'ru', name: 'Русский' },
]

interface LanguageSelectorProps {
  currentLang: string
  onLanguageChange: (lang: string) => void
}

export default function LanguageSelector({
  currentLang,
  onLanguageChange,
}: LanguageSelectorProps) {
  const currentLanguage = languages.find((lang) => lang.code === currentLang) ?? languages[0]

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="border-hair bg-page text-ink hover:border-brand hover:text-brand gap-2"
        >
          <span>{currentLanguage.name}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="border-hair bg-page max-h-[400px] w-48 overflow-y-auto border"
        sideOffset={5}
        avoidCollisions={true}
      >
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => onLanguageChange(lang.code)}
            className={`text-ink hover:bg-surface focus:bg-surface flex cursor-pointer items-center ${
              currentLang === lang.code ? 'bg-surface text-brand font-semibold' : ''
            }`}
          >
            <span className="flex-1">{lang.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
